import React from 'react'
import styled from 'styled-components'
import { Loading } from '@sukiai/components'
import loSto from '../config/loSto'
import { LO_STO, cancelNoteSubmission, sendInitialNoteSubmission, getCompFromCache, RESPONSIVE } from '../lib'
import signNote from '../lib/assets/icons/sign-note-white.svg'

const Terms = styled.div`
  font-size: 15px;
  max-width: 80%;
  margin: 0 auto;
`

const TapButton = styled.button`
  border: none;
  margin: 0 auto;
  font-weight: normal;
  border-radius: 25px;
  padding: .333rem;
  min-width: 298px;
  min-height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(46,95,98);
  color: #fff;
  cursor: pointer;
  font-size: 20px;
`
const styles = {
  modalContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: RESPONSIVE.MODAL_MED_WIDTH,
    width: RESPONSIVE.MODAL_FULL_WIDTH,
    boxSizing: 'border-box',
    minWidth: '300px',
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px rgba(1,1,1,0.2)',
    padding: '30px',
    zIndex: '10000',
    fontSize: '15pt',
    borderRadius: '6px'
  },
  mainContent: {
    width: '100%'
  },
  radioOption: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    fontSize: '15pt'
  },
  icon: {
    width: '24px',
    height: '24px',
    position: 'absolute',
    marginLeft: '-60px',
    marginTop: '-10px'
  },
  selectButton: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    textAlign: 'center',
    color: '#2E5F62',
    width: '99%',
    height: '46px',
    borderRadius: '8px',
    border: '1px solid #2E5F62',
    marginLeft: 'auto',
    paddingLeft: '20px',
    fontSize: '15pt',
    cursor: 'pointer'
  },
  heading: {
    marginBottom: '34px',
    fontWeight: '600',
    fontSize: '15pt'
  },
  divider: {
    width: '100%',
    height: '20px',
    textAlign: 'center'
  },
  optionLabel: {
    fontSize: '14pt',
    letterSpacing: '0.01em',
    marginLeft: '20px',
    fontWeight: '600'
  },
  loading: {
    margin: '40px 0px',
    position: 'relative'
  }
}

export default class SignOffModal extends React.Component {
  async componentDidMount () {
    const compId = loSto.get(LO_STO.CURRENT_COMP_ID)
    const comp = await getCompFromCache(compId)

    sendInitialNoteSubmission(comp)
  }

  async componentWillReceiveProps (nextProps) {
    const shouldDismissModal = nextProps.shouldDismiss && this.props.open
    if (shouldDismissModal) {
      const compId = loSto.get(LO_STO.CURRENT_COMP_ID)
      const comp = await getCompFromCache(compId)

      cancelNoteSubmission(comp)
      nextProps.removeModal()
    }
  }

  render () {
    const { heading, body, loading, handleSignOff } = this.props
    return (
      <div style={styles.modalContainer} onClick={e => e.stopPropagation()} data-cy='sign-off-note-modal'>
        <div style={styles.heading}>
          {heading}
        </div>
        {loading
          ? <Loading style={styles.loading} />
          : (
            <div style={styles.mainContent}>
              <div style={styles.radioOption}>
                <TapButton
                  onClick={() => handleSignOff()}
                  data-cy='handle-sign-off-btn'
                >
                  <div>
                    <img src={signNote} style={styles.icon} alt='Sign Note' />
                  </div>
                  <div>
                    <span>Tap to sign note</span>
                  </div>
                </TapButton>
              </div>
              <div style={styles.divider} />
              <Terms>
                <span>{body}</span>
              </Terms>
            </div>
          )}
      </div>
    )
  }
}
